module.exports = __webpack_public_path__ + "images/281cc3e5afd2abf1dc2a6f2d3577bc6c.webp";